<template>
  <div class="profiles">
    <h3>Profiles</h3>
    <ul
      v-if="profiles.length"
      class="profiles__ul">
      <li
        v-for="(profile, idx) in profiles"
        class="profiles__li"
        :key="idx">
        <span>
          {{ profile.fullname }}
        </span>
        <div>
          <button
            v-if="revealForm && profile.fullname === fullname"
            class="profiles__edit-btn"
            @click.prevent="resetFormFields()">
            Cancel
          </button>
          <button
            v-else
            class="profiles__edit-btn"
            @click="updateProfile(profile.fullname)">
            View Details
          </button>
          <button
            class="profiles__remove-btn"
            @click="$actions.deleteProfile(profile)">
            Remove
          </button>
        </div>
      </li>
    </ul>
    <p v-else>
      Create your first profile
    </p>
    
    <button
      v-show="!revealForm"
      class="btn"
      @click.prevent="revealForm = !revealForm; formType = 'create'"
      v-text="'Add new profile?'">
    </button>

    <form
      v-show="revealForm"
      class="profiles__form-title"
      @submit.prevent="formType === 'update' ? saveProfile() : createProfile()">
      <h5
        v-text="formType == 'update' ? 'Update Profile' : 'New Profile'">
      </h5>

      <label
        class="profile-label"
        for="fullname">
        Full Name*
      </label>
      <input
        type="text"
        class="profile-input"
        id="fullname"
        v-model="formProfile.fullname"
        required
      />

      <label
        class="profile-label"
        for="dob">
        Date of Birth (DD/MM/YYYY)*
      </label>
      <input
        type="text"
        class="profile-input"
        id="dob"
        v-model="formProfile.dob"
        required
      />

      <label
        class="profile-label"
        for="gender">
        Gender*
      </label>
      <select
        class="profile-select"
        id="gender"
        v-model="formProfile.gender"
        required>
        <option value="Male" selected>
          Male
        </option>
        <option value="Female">
          Female
        </option>
        <option value="Prefer not to say">
          Prefer not to say
        </option>
      </select>

      <div v-if="formProfile.gender != 'Male'">
        <label
          class="profile-label"
          for="pregnant">
          Is this patient pregnant or breastfeeding?
        </label>
        <select
          class="profile-select"
          id="pregnant"
          v-model="formProfile.pregnant_or_breastfeeding"
          required>
          <option value="No" selected>
            No
          </option>
          <option value="Yes">
            Yes
          </option>
        </select>
      </div>

      <label
        class="profile-label"
        for="address">
        Address*
      </label>
      <input
        type="text"
        class="profile-input"
        id="address"
        v-model="formProfile.address"
        required
      />

      <label
        class="profile-label"
        for="phone">
        Phone*
      </label>
      <input
        type="text"
        class="profile-input"
        id="phone"
        v-model="formProfile.phone"
        required
      />

      <label
        class="profile-label"
        for="patient_allergies">
        Patient Allergies (optional)
      </label>
      <input
        type="text"
        class="profile-input"
        id="patient_allergies"
        v-model="formProfile.patient_allergies"
      />

      <label
        class="profile-label"
        for="patient_conditions">
        Patient Medical Conditions (optional)
      </label>
      <input
        type="text"
        class="profile-input"
        id="patient_conditions"
        v-model="formProfile.patient_conditions"
      />

      <label
        class="profile-label"
        for="patient_medications">
        Patient Medications (optional)
      </label>
      <input
        type="text"
        class="profile-input"
        id="patient_medications"
        v-model="formProfile.patient_medications"
      />

      <div class="profiles__actions-btns">
        <button
          class="btn"
          v-text="loading ? 'Saving' : 'Save'">
        </button>
        <button
          class="btn btn--cancel"
          @click.prevent="resetFormFields()">
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'AccountProfiles',

  computed: {
    profiles () {
      return this.$store.profiles
    },
    selectedProfile () {
      if (!this.profiles.length) return null
      let profile = this.profiles.find(p => p.fullname === this.fullname)
      return { ...profile }
    },
    loading () {
      return this.$store.loading
    }
  },

  data () {
    return {
      formType: '',
      revealForm: false,
      fullname: '',
      formProfile: {
        fullname: '',
        dob: '',
        gender: 'Male',
        pregnant_or_breastfeeding: '',
        address: '',
        phone: '',
        patient_allergies: '',
        patient_conditions: '',
        patient_medications: ''
      }
    }
  },

  methods: {
    updateProfile (fullname) {
      this.fullname = fullname
      this.formProfile = this.selectedProfile
      this.formType = 'update'
      this.revealForm = true
    },
    saveProfile () {
      this.$actions.saveProfile(this.formProfile)
    },
    createProfile () {
      this.$actions.createProfile(this.formProfile)
    },
    deleteProfile () {
      this.$actions.deleteProfile(this.formProfile)
    },
    resetFormFields () {
      this.revealForm = false
      this.fullname = ''
      this.formProfile.fullname = ''
      this.formProfile.dob = ''
      this.formProfile.gender = 'Male'
      this.formProfile.address = ''
      this.formProfile.phone = ''
      this.formProfile.patient_allergies = ''
      this.formProfile.patient_conditions = ''
      this.formProfile.patient_medications = ''
    }
  },

  watch: {
    profiles () {
      this.revealForm = false
      this.resetFormFields()
    }
  }
}
</script>

<style scoped>
.profiles {
  padding: 1rem 0;
}

.profiles__ul {
  padding: 1rem 0;
  margin : 0 0;
}

.profiles__li:first-of-type {
  border-top: thin solid gainsboro;
}

.profiles__li {
  padding        : .5rem 0;
  display        : flex;
  justify-content: space-between;
  align-items    : center;
  border-bottom  : thin solid gainsboro;
  list-style     : none;
}

.profiles__form-title {
  margin-top: .75rem;
}

.profile-label {
  margin-bottom : .1rem;
  font-size     : .75rem;
  font-weight   : 300;
  letter-spacing: .025rem;
  text-transform: capitalize;
}

.profile-input,
.profile-select {
  width        : 100%;
  padding      : .25rem .5rem;
  margin-bottom: .75rem;
  border-color : black;
  border-radius: .15rem;
}

.profiles__edit-btn,
.profiles__remove-btn {
  font-size      : .75rem;
  font-weight    : 600;
  text-decoration: underline;
  color          : red;
}

.profiles__remove-btn {
  margin-left: 1rem;
}

.btn--cancel {
  background: red;
}

.profiles__actions-btns {
  margin-bottom: 1rem;
}
</style>
